import bunyan from "bunyan";

const loggerClient =
  typeof window === "undefined"
    ? bunyan.createLogger({
        name: "blog_finanzero_nextjs",
        level: "error",
      })
    : console;

export default loggerClient;
